module.exports = __webpack_public_path__ + "static/media/intro2.b1f562de.jpg";